// IMPORT PACKAGE REFERENCES

import React, {Fragment} from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import firebase from '../../Config/Firebase';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logout } from '../State/Actions/UserActions';

// COMPONENT

class Footer extends React.Component {

    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout(event) {
        event.preventDefault(); 

        this.props.logout();
    }

    render() {
        return (
            <Fragment>
                {/* <div className="footer">
                    <p>&copy; 2018 - Triton Hearing • Version 1.0 </p>
                </div> */}
            </Fragment>
        )
    }
    
}

Footer.propTypes = {
    history: PropTypes.object.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { loggedIn } = state.userReducer;
    return { loggedIn };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ logout }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));

// EXPORT COMPONENT

export { hoc as Footer };

